// @flow
import { combineReducers } from 'redux';

import * as types from '../types/network';
import * as common from './common';

export type NetworkState = {
  connected: boolean,
};

const connected = common.toggle({
  turnedOn: [types.NETWORK_CONNECTED],
  turnedOff: [types.NETWORK_DISCONNECTED],
  default: true, 
});

const network = combineReducers({
  connected,
});

export default network;

export const isConnected = (state: NetworkState): boolean => state.connected;



// WEBPACK FOOTER //
// ./src/scripts/reducers/network.js